import { useState, createContext, useContext } from "react";
import ReactDOM from "react-dom";

const UserContext = createContext();
export  {UserContext};
